import type { CommunityMemberPermissionsGroup, PermissionActions } from 'src/types'

export type OwnerCollectionsPermissions = {
  group: `${CommunityMemberPermissionsGroup}`
  actions?: PermissionActions[]
}

export type CommunityProps = {
  id: number
  icon: string
  isDefaultEnableComments: boolean
  isHide: boolean
  name: string
  description: string
  ownerPictureUrl: string
  imageDescription: string
  idGroup: number
  owner: string
  lastPostDate: number
  followersCount: number
  ownerId: number
  isOwner: boolean
  coverImageURL: string
  coverDescription?: string
  hotlink: string
  imageURL: string
  isOwnerOrFollower: boolean
  type: number
  productId?: number
  ownerCollectionPermissions?: OwnerCollectionsPermissions
  permissions?: OwnerCollectionsPermissions
  isCollaborative?: boolean
}

export type CommunitiesResponse = { data: CommunityProps[]; nextPageParam: number }

export type GetAllProps = {
  signal?: AbortSignal
  rows?: number
  slug: string
}

export type CommunityGroupGetResponse = [
  {
    communities: {
      data: CommunityProps[]
    }
  } & CommunityGroupCreateResponse
]

export type CommunityGroupCreateResponse = {
  id: number
  name: string
  slug: string
  order: number
}

const PUBLIC_VALUE = 1
const EXCLUSIVE_VALUE = 3
const OPEN_VALUE = 2
const PAID_VALUE = 4

export const EDIT_COMMUNITY_SUCCESS = 'EDIT_COMMUNITY_SUCCESS'

export enum COMMUNITY_TYPE {
  PUBLIC = PUBLIC_VALUE,
  OPEN = OPEN_VALUE,
  EXCLUSIVE = EXCLUSIVE_VALUE,
  PAID = PAID_VALUE
}

export type EditCommunityProps = {
  name: string
  description: string
  icon: string
  groupId: number
  id: number
  type: COMMUNITY_TYPE
  imageDescription?: string
  imageURL?: string
  coverImage?: string
  coverDescription?: string
  image?: string
  collaborativeContent: boolean
  hide: boolean
}
